import type { FlowStep } from "@zworks/console-contracts";

/** One starter workflow. Steps use catalogue recipes, so a created draft reads as ready. */
export interface WorkflowTemplate {
  id: string;
  name: string;
  summary: string;
  steps: FlowStep[];
}

function step(name: string, kind: string, gate: boolean, recipe?: string): FlowStep {
  return recipe ? { name, kind, gate, recipe } : { name, kind, gate };
}

/** The four starters from the Studio spec: bug fix, release, audit, and nightly check. */
export const workflowTemplates: readonly WorkflowTemplate[] = [
  {
    id: "bug-fix-pr",
    name: "Bug fix to pull request",
    summary: "Plan, fix, review, and check the diff before opening the pull request.",
    steps: [
      step("Plan the fix", "planner", false, "auto.plan"),
      step("Implement the fix", "task", false, "agent.work"),
      step("Review the change", "task", false, "agent.review"),
      step("Read the diff", "task", false, "repo.diff"),
      step("Run unit tests", "task", false, "node.test"),
    ],
  },
  {
    id: "release-approval",
    name: "Release with approval",
    summary: "Build, hold for an approver, then roll out. The gate decides the release.",
    steps: [
      step("Plan the release", "planner", false, "auto.plan"),
      step("Production build", "task", false, "node.build"),
      step("Approve the release", "approval", true),
      step("Roll out", "deploy", false, "deploy.roll"),
    ],
  },
  {
    id: "security-audit",
    name: "Security audit",
    summary: "Scan for secrets, audit dependencies, and record the findings.",
    steps: [
      step("Plan the audit", "planner", false, "auto.plan"),
      step("Scan for secrets", "task", false, "repo.scan-secrets"),
      step("Audit dependencies", "task", false, "node.audit"),
      step("Record the findings", "note", false, "auto.note"),
    ],
  },
  {
    id: "nightly-check",
    name: "Nightly check",
    summary: "Probe reachability, headers, and the certificate, then record the result.",
    steps: [
      step("Check reachability", "task", false, "probe.http"),
      step("Check headers", "task", false, "probe.headers"),
      step("Check the certificate", "task", false, "probe.tls"),
      step("Record the result", "note", false, "auto.note"),
    ],
  },
];
